import { SKINS, SKIN_LABELS } from "../skin";

// Shares the `.mood` slide-up sheet styling; Mood was just its first user.
export default function SkinSheet({
  open,
  skin,
  isProFeaturesLocked,
  debugMode = false,
  onSkinChange,
  onUpgradeClick,
}) {
  const locked = !!isProFeaturesLocked && !debugMode;

  const pick = (value) => {
    // Color stays reachable while locked; the rest is Pro.
    if (locked && value !== "color") {
      onUpgradeClick?.();
      return;
    }
    onSkinChange?.(value);
  };

  return (
    <div
      id="mood-sheet"
      className={`mood mood--skin${open ? " mood--open" : ""}${
        locked ? " mood--locked" : ""
      }`}
      aria-label="Skin"
      aria-hidden={!open}
      {...(!open ? { inert: true } : {})}
    >
      <div className="mood__header">
        <div className="content__title">Skin</div>
        <p className="mood__subtitle">Pick how the popup looks.</p>
      </div>

      <div className="mood__chips-wrap">
        <div className="mood__chips">
          {SKINS.map((value) => {
            const isSelected = skin === value;
            const isLocked = locked && value !== "color";
            return (
              <button
                key={value}
                type="button"
                className={`mood__chip${isSelected ? " mood__chip--selected" : ""}${
                  isLocked ? " mood__chip--locked" : ""
                }`}
                onClick={() => pick(value)}
                aria-disabled={isLocked || undefined}
                aria-pressed={isSelected}
                title={SKIN_LABELS[value]}
                tabIndex={open ? 0 : -1}
              >
                <span className="mood__chip-name">{SKIN_LABELS[value]}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
